if (!customElements.get('video-section')) {
  customElements.define('video-section', class VideoSection extends HTMLElement {
    static get observedAttributes() {
      return [`stop`, '']
    }
    constructor() {
      super();
      this.videoDesktop = this.dataset.desktop
      this.videoMobile = this.dataset.mobile
      this.videoElement = this.querySelector('.js-video')
      this.playBtn = this.dataset.playbtn
      this.poster = this.videoElement.poster
      this.usePoster = false
      if (this.poster) {
        this.posterImageMobile = this.dataset.posterm
        this.posterImageDesktop = this.dataset.posterd
        this.usePoster = true
      }
      if (window.innerWidth < 767) {
        this.videoElement.src = this.videoMobile;
        this.usePoster ? this.videoElement.poster = this.posterImageMobile : ''
      } else {
        this.videoElement.src = this.videoDesktop;
        this.usePoster ? this.videoElement.poster = this.posterImageDesktop : ''
      }
      if (this.playBtn === 'true') {
        this.play = this.querySelector('.js-play')
        this.play.addEventListener('click', (e) => {
          this.handleClick();
          this.handleOutOfView();
        })
      }
    }
    attributeChangedCallback() {
      this.stop ? this.videoPause() : '';
    }
    get stop() {
      return this.hasAttribute('stop')
    }

    set stop(val) {
      if (val) {
        this.setAttribute('stop', '')
      } else {
        this.removeAttribute('stop')
      }
    }
    handleClick() {
      this.videoElement.paused ? this.videoPlay() : this.videoPause()
    }
    videoPlay() {
      this.videoElement.play()
      this.classList.add('is-playing')
    }
    videoPause() {
      this.videoElement.pause()
      this.classList.remove('is-playing')
    }
    handleIntersection(entries) {
      entries.map((entry) => {
        entry.isIntersecting ? entry.target.removeAttribute('stop', '') : entry.target.setAttribute('stop', '');
      });
    }
    handleOutOfView() {
      this.target = this;
      const observer = new IntersectionObserver(this.handleIntersection);
      observer.observe(this.target);
    }
  });
}
